






import { Vue, Component } from 'vue-property-decorator';
import appConfig from '../../appConfig';

@Component
export default class FrequentlyAskedQuestionsConfirm extends Vue {
    get faqUrl(): string {
        return appConfig.faqPageUrl;
    }
}
